import src from "IMAGE";
export default { src, width: 268, height: 603, blurWidth: 4, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAYAAADeM14FAAAARElEQVR42k2NOQ4AIAgE+f9LPQDtxAqFSKTYhJ3AAAWXRiothRg6i9LcClZwiMdBf8XSSC7gD9xhFNMW1CttnBz5pZ0fWuR547nGfyMAAAAASUVORK5CYII="};
